module.exports = __webpack_public_path__ + "assets/img/ic-info-b.a256cbe6.svg";